import React from "react";
import EmployeeInformation from "./EmployeeInformation";
import RequestDetails from "./RequestDetails";
import PermitApprovers from "../PermitApprovers";
import { WorkPermitApprover } from "../../../constants/common";
import Wrapper from "../Wrapper";

interface OfficeAccessAuthorizationPermitPDFProps {
  permitDetails: {
    s_EmployeeName: string;
    s_EmployeeNumber: string;
    s_MobileNumber: string;
    s_Department: string;
    requestedServices: {
      serviceNameEn: string;
    }[];
    s_OfficeNumber: string;
    dt_RequestDate: any;
    approvers: WorkPermitApprover[];
  };
}

const OfficeAccessAuthorizationPermitPDF: React.FC<OfficeAccessAuthorizationPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title="Office Access Authorization" >
      <EmployeeInformation permitDetails={permitDetails} />
      <RequestDetails permitDetails={permitDetails} />
      <PermitApprovers sectionNumber={3} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default OfficeAccessAuthorizationPermitPDF;
